var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.82 22.59a1 1 0 0 1 1-1h9.54a1 1 0 0 1 0 2h-9.54a1 1 0 0 1-1-1m0 3.82a1 1 0 0 1 1-1h9.54a1 1 0 1 1 0 2h-9.54a1 1 0 0 1-1-1m1 2.82a1 1 0 1 0 0 2h9.54a1 1 0 1 0 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.41 13h-9.64v.95H15a1 1 0 0 0-1 1V35a1 1 0 0 0 1 1h17.18a1 1 0 0 0 1-1V14.95a1 1 0 0 0-1-1h-3.77zm0 2.95a2.916 2.916 0 0 1-2.91 2.87h-3.82a2.916 2.916 0 0 1-2.91-2.87H16V34h15.18V15.95zm-7.64-.04V15h5.64v.91c0 .498-.412.91-.91.91h-3.82a.916.916 0 0 1-.91-.91",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFeedback);
export default __webpack_public_path__ + "static/media/IcoFeedback.0948370dc9f4107e0ceb4acdc7cd6403.svg";
export { ForwardRef as ReactComponent };